<template><div><h1 id="einstellungen-zu-aufgaben" tabindex="-1"><a class="header-anchor" href="#einstellungen-zu-aufgaben"><span>Einstellungen zu Aufgaben</span></a></h1>
<p>Einstellungen zu Aufgaben — Parametrisierung der Aufgaben</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Eine Aufgabe ist eine, vom System oder manuell ausgelöste, Meldung. In dieser Tabelle werden die Parametrisierungen für die Aufgaben vorgenommen. Dabei werden die Aufgaben aus der Stammtabelle gewählt und dann zusätzliche Einstellungen vorgenommen (z.B. Auslösung nach Höhe Bestellbetrag).</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Einstellungen zu Aufgaben</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr./Nummer</dt>
<dd>Nummer für die definierte Aufgabe zur Identifikation</dd>
<dt>Aufgabe</dt>
<dd>Auswahl Aufgabe (hardcodiert)
<table>
<thead>
<tr>
<th>Aufgabe</th>
<th>Beschreibung aus Aufgaben-Stammtabelle</th>
<th>Erklärung</th>
</tr>
</thead>
<tbody>
<tr>
<td>AdresseHatMerkmal</td>
<td>Adresse hat Merkmal</td>
<td></td>
</tr>
<tr>
<td>Adresse mit Merkmal mutiert</td>
<td>Adresse mit Merkmal mutiert</td>
<td></td>
</tr>
<tr>
<td>Adressmutation</td>
<td>Alte Adresse unbekannt</td>
<td></td>
</tr>
<tr>
<td>ads</td>
<td>Adress-Sperrmerkmal</td>
<td>Adresse hat ein Sperrmerkmal.</td>
</tr>
<tr>
<td>adv</td>
<td>Adressvalidierung</td>
<td>Eine Adresse hat einen Adresszusatz und/oder die Strasse ist nicht ausgefüllt.</td>
</tr>
<tr>
<td>adw</td>
<td>Adress-Warn-Merkmal</td>
<td>Adresse hat ein Warnmerkmal.</td>
</tr>
<tr>
<td>alt</td>
<td>Minderjährig</td>
<td>Aufgabe wird ausgelöst, abhängig vom eingetragenen Alter.</td>
</tr>
<tr>
<td>ars</td>
<td>Artikel-Sperr-Merkmal</td>
<td>Ein Artikel in der Auftragsposition hat ein Sperrmerkmal.</td>
</tr>
<tr>
<td>artrue</td>
<td>Auftrag mit Artikelrückstand</td>
<td>Es sind nicht alle Artikel im Auftrag lieferbar.</td>
</tr>
<tr>
<td>arw</td>
<td>Artikel-Warn-Merkmal</td>
<td>Ein Artikel in der Auftragsposition hat ein Warnmerkmal.</td>
</tr>
<tr>
<td>Auslandbestellung</td>
<td>Bestellungen aus dem Ausland</td>
<td>Prüft, ob ein Warenkauf mit einer ausländischen Adresse aufgegeben wurde. Diese Aufgabe benötigt keine weiteren Parameter.</td>
</tr>
<tr>
<td>ausstehendeZahlung</td>
<td>ausstehende Zahlung</td>
<td></td>
</tr>
<tr>
<td>bcn</td>
<td>IID</td>
<td>Instituts-Identifikation, ehemals Bankenclearingnummer stimmt nicht oder ist ungültig (gilt für Zusagen/LSV).</td>
</tr>
<tr>
<td>Bezahlt ohne zugeordnete Spende</td>
<td>Bezahlt ohne zugeordnete Spende</td>
<td></td>
</tr>
<tr>
<td>BounceOhneEKomm</td>
<td>Bounce ohne EKommunikation</td>
<td></td>
</tr>
<tr>
<td>cca</td>
<td>Kreditkartenzahlung</td>
<td>Die Zahlungsart ist &quot;External&quot;</td>
</tr>
<tr>
<td>CheckArtikelBestellpunkt</td>
<td>Bestellpunkt bei den Artikeln aktiv benachrichtigen</td>
<td></td>
</tr>
<tr>
<td>cou</td>
<td>Couvert</td>
<td>Zu dieser Bestellung müssen manuell noch Couverts erfasst werden (gilt nur temporär)</td>
</tr>
<tr>
<td>dop</td>
<td>Mehrfachbestellungen</td>
<td>Prüft, ob in einem bestimmten Zeitraum (eingetragen im Feld &quot;Wert&quot;, in Sekunden) ein 2. Auftrag vom selben Auftraggeber erfasst worden ist.</td>
</tr>
<tr>
<td>dub</td>
<td>Adressdublette</td>
<td>Die Adresse hat eine E-Mail, die bereits bei einer &quot;anderen&quot; Adresse enthalten ist. Dies weist auf eine potentielle Dublette oder eine Haushaltsverbindung hin.</td>
</tr>
<tr>
<td>dublettenBereinigung</td>
<td>Problem bei Dubletten zusammenführen</td>
<td></td>
</tr>
<tr>
<td>EloquaWarnung</td>
<td>Eloqua-Abgleichs Warnungen</td>
<td>Bei Unstimmigkeiten beim Abgleich zwischen Eloqua und funtrade wird eine Aufgabe erstellt, die Details sind in der erstellten Aufgabe aufgeführt.</td>
</tr>
<tr>
<td>ema</td>
<td>E-Mail NOK</td>
<td>Diese Aufgabe kann nach Überschreitung einer Anzahl abgewiesener E-Mails (Bounces) ausgelöst werden.</td>
</tr>
<tr>
<td>EMailPubNok</td>
<td>Problematische E-Mail-Publikationssituation</td>
<td>Mindestens zwei Adressen haben eine E-Mail Publikation mit demselben E-Mail Telekommunikationseintrag.</td>
</tr>
<tr>
<td>fehltK-Art</td>
<td>FTML: fehlt K-Art zum Ereignis</td>
<td></td>
</tr>
<tr>
<td>frm</td>
<td>Firma</td>
<td></td>
</tr>
<tr>
<td>ftmlFreeText</td>
<td>FreeText in FTML</td>
<td></td>
</tr>
<tr>
<td>FTMLWiderspruechlicheAdrDaten</td>
<td>Widersprüchliche Adressdaten in FTML</td>
<td></td>
</tr>
<tr>
<td>gueltigKK</td>
<td>Gueltigkeitsdatum der Kreditkarte ist abgelaufen</td>
<td></td>
</tr>
<tr>
<td>HardBounce</td>
<td>Hard-Bounce</td>
<td></td>
</tr>
<tr>
<td>hg-jobs</td>
<td>Jobs</td>
<td>Prüft, ob ein Job abgebrochen oder fehlerhaft beendet wurde. Bei dieser Aufgabe können im Parameter mehrere Stati definiert werden, z.B. 1,2</td>
</tr>
<tr>
<td>inx</td>
<td>Inxmail NOK</td>
<td></td>
</tr>
<tr>
<td>KKZahlungGuthaben</td>
<td>FTML Auftrag: Es gibt höherer Guthaben als Kreditkarte Zahlung</td>
<td></td>
</tr>
<tr>
<td>KorrErmSenden</td>
<td>LSV Ermächtigung an Bank gesandt</td>
<td></td>
</tr>
<tr>
<td>KorrFormSenden</td>
<td>Formular an Förderer gesandt</td>
<td></td>
</tr>
<tr>
<td>KorrStornoSenden</td>
<td>Stornobestätigung gesandt</td>
<td></td>
</tr>
<tr>
<td>MehrereVornamen</td>
<td>Mehrere Vornamen (Personen) im Feld Vorname</td>
<td></td>
</tr>
<tr>
<td>Mitteilung</td>
<td>Mitteilung</td>
<td>Löst eine Aufgabe aus, wenn die FTML-Transaktion eine Mitteilung enthält. Die Aufgabe enthält als Beschreibung den Inhalt aus den Tags &quot;Subject&quot; und &quot;Content&quot;. Wenn im &quot;Subject&quot; &quot;Korrespondenz&quot; eingetragen ist, wird keine Aufgabe ausgelöst.</td>
</tr>
<tr>
<td>Mutation</td>
<td>Mutation</td>
<td></td>
</tr>
<tr>
<td>NameGrossKlein</td>
<td>Name oder Vorname alles gross oder klein geschrieben</td>
<td></td>
</tr>
<tr>
<td>NameVertauscht</td>
<td>Vorname/Nachname vertauscht</td>
<td></td>
</tr>
<tr>
<td>Neukunde</td>
<td>Neukunde</td>
<td>Die Adresse hat zum ersten mal bestellt.</td>
</tr>
<tr>
<td>nichtKorrekteAdresse</td>
<td>Postalisch nicht korrekte Adresse</td>
<td>Diese Aufgabe wird ausgelöst, wenn eine postalisch nicht korrekte Adresse geliefert wird. Unterstützte Transaktionen &quot;MAIN,SPE,CMP,WVK,ERG&quot;. Beispiele für Kontext: &quot;CMP,SPE,WVK&quot; bedeutet Aufgabe wird erstellt wenn die Transaktion CMP oder SPE oder WVK enthaltet. &quot;CMP,SPE,-WVK&quot; bedeutet Aufgabe wird erstellt wenn die Transaktion CMP oder SPE aber keine WVK enthaltet. &quot;CMP,+SPE,-WVK&quot; bedeutet Aufgabe wird erstellt wenn die Transaktion CMP, zwingend SPE aber keine WVK enthaltet</td>
</tr>
<tr>
<td>offeneRechnung</td>
<td>Offene Rechnung ausserhalb Zahlungsziel</td>
<td></td>
</tr>
<tr>
<td>P-Dokument Besprechung</td>
<td>P-Dokument Besprechung</td>
<td></td>
</tr>
<tr>
<td>P-Dokument Endversion</td>
<td>Endversion erstellen</td>
<td></td>
</tr>
<tr>
<td>P-Dokument erste Version</td>
<td>P-Dokument erste Version</td>
<td></td>
</tr>
<tr>
<td>Person im Filter markiert</td>
<td>Person im Filter markiert</td>
<td></td>
</tr>
<tr>
<td>PersonSperreDubBer</td>
<td>Personensperre nach Dublettenbereinigung</td>
<td></td>
</tr>
<tr>
<td>ple</td>
<td>Zusagenbetrag</td>
<td>Diese Aufgabe wird ausgelöst, wenn der neue Zusagebetrag kleiner ist als der versprochene Zusagenbetrag bzw. Standardbetrag.</td>
</tr>
<tr>
<td>pleexist</td>
<td>Zusage existiert bereits</td>
<td></td>
</tr>
<tr>
<td>PostAdressChangeAufgabe</td>
<td>Postalisch geänderte Adresse</td>
<td>Diese Aufgabe wird ausgelöst, wenn eine Adresse fehlerhaft geliefert wird (z.B. Strasse in Hausnummer). funtrade korrigiert es auf eine postalische korrekte Adresse. Die Aufgabe dient zu Kontrollzwecken der geänderten Adresse. Unterstützte Transaktionen &quot;MAIN,SPE,CMP,WVK,ERG&quot;. Beispiele für Kontext: &quot;CMP,SPE,WVK&quot; bedeutet Aufgabe wird erstellt wenn die Transaktion CMP oder SPE oder WVK enthaltet. &quot;CMP,SPE,-WVK&quot; bedeutet Aufgabe wird erstellt wenn die Transaktion CMP oder SPE aber keine WVK enthaltet. &quot;CMP,+SPE,-WVK&quot; bedeutet Aufgabe wird erstellt wenn die Transaktion CMP, zwingend SPE aber keine WVK enthaltet</td>
</tr>
<tr>
<td>projektStartbedingungen</td>
<td>Projekt: Startbedingungen erfüllt</td>
<td></td>
</tr>
<tr>
<td>projektVollfinanziert</td>
<td>Projekt: vollfinanziert</td>
<td></td>
</tr>
<tr>
<td>PublPersSperre</td>
<td>Publikationsbestellung von Person mit Personensperre</td>
<td></td>
</tr>
<tr>
<td>RaiseNowZusage</td>
<td>RaiseNow: FTML Zusage</td>
<td></td>
</tr>
<tr>
<td>ref</td>
<td>Refusé</td>
<td>Prüft, ob ein Refusé auf eine Adresse im definierten Adressfilter erfasst wurde.</td>
</tr>
<tr>
<td>regelSpender</td>
<td>regelmässiger Spender</td>
<td></td>
</tr>
<tr>
<td>sal</td>
<td>Saldo bei Bestellungen</td>
<td>Diese Aufgabe wird ausgelöst, sobald eine Adresse den im Feld &quot;Wert&quot; eingetragenen Saldo über- oder unterschreitet.</td>
</tr>
<tr>
<td>Scan</td>
<td>Scan MD Zusage</td>
<td></td>
</tr>
<tr>
<td>SoftBounce</td>
<td>Soft-Bounce</td>
<td></td>
</tr>
<tr>
<td>speavi</td>
<td>Buchungen einlesen - Spenden avisieren</td>
<td>Response erfüllt definierten Wert mit Umsatztyp oder Adresse hat definiertes Merkmal.</td>
</tr>
<tr>
<td>Spezialauftrag</td>
<td>Spezialauftrag</td>
<td></td>
</tr>
<tr>
<td>spi</td>
<td>Spenden Internet</td>
<td></td>
</tr>
<tr>
<td>spp</td>
<td>Spendenartikel mit Porto</td>
<td>In den Auftragspositionen sind nue Spenden enthalten und trotzdem ist ein Portobetrag vorhanden.</td>
</tr>
<tr>
<td>tel</td>
<td>Telekom Eintrag</td>
<td>Der Telekommunikationseintrag entspricht nicht den Validierungsregeln von funtrade (z.B. E-Mailadresse wie hans.muster@provider@ch).</td>
</tr>
<tr>
<td>termin</td>
<td>Termin, manuell erfasst</td>
<td></td>
</tr>
<tr>
<td>tfo</td>
<td>Telekom-Format</td>
<td>Die Formatierung der Telekommunikationsdaten entspricht nicht den Festlegungen in der Tabelle Telekommunikationsformate.</td>
</tr>
<tr>
<td>tit</td>
<td>Titel, Grad</td>
<td>Der Titel ist nicht in der Tabelle Titel vorhanden.</td>
</tr>
<tr>
<td>tst</td>
<td>Testbestellung</td>
<td></td>
</tr>
<tr>
<td>VerdankungAufbereiten</td>
<td>einzelne Verdankung aufbereiten</td>
<td></td>
</tr>
<tr>
<td>Verdankung auf MD Zusage</td>
<td>Verdankung für MD Zusage erstellen</td>
<td></td>
</tr>
<tr>
<td>Verdankung auf Zahlung</td>
<td>Verdankung für Zahlungseingang MD erstellen</td>
<td></td>
</tr>
<tr>
<td>Versand P-Dokument</td>
<td>Versand P-Dokument</td>
<td></td>
</tr>
<tr>
<td>vol</td>
<td>Bestellvolumen</td>
<td>Das Bestellvolumen überschreitet oder unterschreitet den im feld &quot;Wert&quot; eingetragenen Betrag.</td>
</tr>
<tr>
<td>VornameGeschlecht</td>
<td>Vorname Geschlecht stimmt nicht überein</td>
<td></td>
</tr>
<tr>
<td>VornameUnvollstaendig</td>
<td>Vorname ist unvollständig oder leer</td>
<td></td>
</tr>
<tr>
<td>Zahlung eingegangen</td>
<td>Zahlung auf Spendenzusage MD ist erfolgt</td>
<td></td>
</tr>
<tr>
<td>Zusage3Z</td>
<td>Zusagen mit Drittzahler</td>
<td></td>
</tr>
<tr>
<td>zusmut</td>
<td>Zusagenmutation</td>
<td></td>
</tr>
</tbody>
</table>
</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung zur Aufgabe</dd>
<dt>verarbeiten</dt>
<dd>Verarbeiten ja/nein. Bestellungen werden nur fakturiert wenn dieser Schalter auf &quot;ja&quot; gesetzt ist. Bei Aufgaben mit der Option &quot;nein&quot; muss die Fakturierung in der Aufgabenbearbeitung manuell ausgelöst werden. Die Bereiche Zusagenfakturierung und Spendefakturierung sind davon nicht betroffen!</dd>
<dt>Modul</dt>
<dd>Bezeichnet das funtrade-Modul, welches geöffnet werden soll, wenn in der <a class="link" href="ft.refdata.aufgabenbearbeitung.html" title="Aufgabenbearbeitung">Aufgabenbearbeitung</a> die Funktion &quot;Kontext öffnen&quot; ausgeführt wird. Z.B. wird mit dem Modul &quot;adr&quot; die Personenansicht mit der betreffenden Adresse geöffnet.</dd>
<dt>Zuständig</dt>
<dd>Eingabe/Auswahl einer organisatorischen Einheit (OE). Die erstellten Aufgaben werden zu dieser OE zugeordnet.</dd>
<dt>E-Mail</dt>
<dd>Eingabe/Auswahl einer oder mehrerer E-Mail Adresse(n). Personen die per E-Mail benachrichtigt werden, sobald die entsprechende Aufgabe erstellt wird.</dd>
<dt>Tage offen</dt>
<dd>Die Aufgabe wird automatisch nach Anzahl der definierten Tage geschlossen.</dd>
<dt>Parameter</dt>
<dd>XML-Parameter für die Definition der variablen Faktoren wie z.B. Betragshöhe, Merkmal, etc.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.aufgabenbearbeitung.html" title="Aufgabenbearbeitung">Aufgabenbearbeitung</RouteLink></p>
</div></template>


